<template>
  <div>
    <el-row>
      <el-col :span="12">
        <el-form label-position="left">
          <el-form-item :label="$t('duck.device')">
            <el-select v-model="selectedDuck" @change="onDuckChange" value-key="deviceId">
              <el-option v-for="item in ducks" :key="item.deviceId" :label="item.macAddress" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <hr />

      </el-col>
    </el-row>
    <el-row v-if="selectedDuck">
      <el-col :span="12">
        <el-form ref="duckConfigForm" :model="duckConfig" :rules="duckConfigRules" label-position="left">
          <el-form-item label-width="180px" :label="$t('duck.sampleSize')" prop="sampleSize">
            <el-input-number :min="100" :max="20000" v-model="duckConfig.sampleSize" />
          </el-form-item>
          <el-form-item label-width="180px" :label="$t('duck.voltageReference')" prop="voltageReference">
            <el-select v-model="duckConfig.voltageReference">
              <el-option v-for="item in voltageReferences" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label-width="180px" :label="$t('duck.samplingRate')" prop="samplingRate">
            <el-select v-model="duckConfig.samplingRate">
              <el-option v-for="item in samplingRates" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- add sensor button mimi -->
          <el-button v-if="checkPermission('addSensor')" style="margin-top:10px; margin-bottom:10px" size="mini"
            type="default" icon="el-icon-plus" @click="addSensor()">{{ $t("point.addSensor") }}</el-button>
          <el-tabs v-model="activeSensor" @tab-add="addSensor" tab-position="top" type="card" class="duckConfig"
            style="padding-right:10px;margin-top:5px">
            {{sensors,'----'}}
            <el-tab-pane v-for="(sensor, i) in duckConfig.sensors" :label="sensor.displayName" :name="i.toString()"
              :key="sensor.name + '_' + i"
              style="min-height:200px;border:1px solid rgb(221 221 221); padding:25px; border-radius:0px 0px 5px 5px">
              <el-form-item label-width="120px" :label="$t('duck.sensor')" :prop="'sensors[' + i + '].name'"
                :rules="sensorRules.name">

                <el-select v-model="sensor.name" @change="sensor.channels.map(x => x.channel = '')">
                  <el-option v-for="item in duckSensors" :key="item.sensor" :label="item.displayName"
                    :value="item.sensor" />
                </el-select>
              </el-form-item>
              <el-form-item label-width="120px" :label="$t('duck.displayName')" :prop="'sensors[' + i + '].displayName'"
                :rules="sensorRules.displayName">
                <el-input style="width:120px" v-model="sensor.displayName"
                  :prop="'duckConfig.sensors[' + i + '].displayName'"></el-input>
              </el-form-item>
              <el-form-item :label="$t('duck.minMaxVoltage')" :prop="'sensors[' + i + '].minMaxVoltage'"
                :rules="sensorRules.minMaxVoltage">
                <MinMaxInput v-model="sensor.minMaxVoltage"></MinMaxInput>
              </el-form-item>
              <el-form-item :label="$t('duck.minMaxValue')" :prop="'sensors[' + i + '].minMaxValue'"
                :rules="sensorRules.minMaxValue">
                <MinMaxInput v-model="sensor.minMaxValue"></MinMaxInput>
              </el-form-item>
              <el-form-item :label="$t('duck.activeChannels')" :prop="'sensors[' + i + '].channels'"
                :rules="sensorRules.channels">
                <div class="duckChannelSelect"
                  :class="{ active: (sensor.channels.some(c => c.order == ch)), disabled: isDisabled(sensor, ch) }"
                  @click="toggleChannel(sensor, ch)" v-for="ch in [1, 2, 3, 4, 5, 6, 7, 8]">
                  {{ ch }}</div>

              </el-form-item>
              <el-form-item v-for="(ch, channelIndex) in sensor.channels" :key="ch.channel + '_' + channelIndex"
                style="" :label="$t('channel') + ch.order"
                :prop="'sensors[' + i + '].channels[' + channelIndex + '].channel'" :rules="channelRules.channel">
                <el-select v-model="ch.channel">

                  <el-option v-for="channel in channelOptions(sensor)" :key="channel.value" :label="channel.label"
                    :value="channel.value" :disabled="channel.disabled">
                  </el-option>
                </el-select>

              </el-form-item>
              <div style="text-align: right;">

                <el-button @click="deleteDuckSensor(i)" size="mini" type="danger" icon="el-icon-delete">
                </el-button>
              </div>
            </el-tab-pane>

          </el-tabs>
          <el-form-item>
            <el-button @click="save" size="mini" ype="default">
              {{ $t("common.save") }}
            </el-button>
          </el-form-item>
        </el-form>

      </el-col>
      <el-col :span="12">
        <el-form>
          <el-form-item :label="$t('duck.periodic')">
            <el-select v-model="duckPeriod" @change="updatePeriod">
              <el-option v-for="item in avaliablePeriods" :key="item.value" :label="item.friendly"
                :value="item.seconds">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <!-- trash icon -->
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="deletePeriodic()">{{ $t("common.delete")
            }}</el-button>
          </el-form-item>

          <Trigger v-if="selectedDuck" :device="selectedDuck.macAddress"></Trigger>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>



<script>
import MinMaxInput from "./Input-tag/minMaxInput.vue";
import { mapState, mapActions } from "vuex";
import Trigger from "./Device_Trigger";

export default {
  name: "Duck",
  components: {
    MinMaxInput, Trigger
  },
  data() {
    let minMaxValidator = (rule, value, callback) => {
      //check value if array then size of 2
      //first value shoul be lower than second value
      if (Array.isArray(value)) {
        if (value.length == 2) {
          if (value[0] >= value[1]) {
            callback(new Error(this.$t('duck.minMaxValueError')));
          } else {
            callback();
          }
        } else {
          callback(new Error(this.$t('duck.minMaxValueError')));
        }
      } else {
        callback(new Error(this.$t('duck.minMaxValueError')));
      }
    };
    let atLeastOneChannel = (rule, value, callback) => {
      console.log(value);
      if (Array.isArray(value)) {
        if (value.length == 0) {
          callback(new Error(this.$t('duck.atleastOneChannel')));
        } else {
          callback();
        }
      } else {
        callback(new Error(this.$t('duck.atleastOneChannel')));
      }
    };
    return {
      results: {},
      formLoading: false,
      selectedDuck: "",
      voltageRef: "",
      activeSensor: "",
      sampleSize: 10000,
      voltageReferences: [{
        value: true,
        label: this.$t('duck.voltageReferanceExternal')
      }, {
        value: false,
        label: this.$t('duck.voltageReferanceInternal')

      }],
      duckConfigRules: {
        "voltageReference": [
          { required: true, message: this.$t("common.required"), trigger: 'blur' },
        ],
        "sampleSize": [
          { required: true, message: this.$t("common.required"), trigger: 'blur' },
        ],
        "samplingRate": [
          { required: true, message: this.$t("common.required"), trigger: 'blur' },
        ],

      },
      sensorRules: {
        "channels": [{
          required: true, validator: atLeastOneChannel, message: this.$t("common.required"), trigger: 'blur'
        }],
        "name": [
          { required: true, message: this.$t("common.required"), trigger: 'blur' },
        ],
        "displayName": [
          { required: true, message: this.$t("common.required"), trigger: 'blur' },
        ],
        "minMaxValue": [
          { "validator": minMaxValidator, message: this.$t("common.invalidRange"), trigger: 'blur' },
        ],
        "minMaxVoltage": [
          { "validator": minMaxValidator, message: this.$t("common.invalidRange"), trigger: 'blur' },
        ],
      },
      channelRules: {
        "channel": [
          { required: true, message: this.$t("common.required"), trigger: 'blur' },
        ]
      },
      validSensors: [],
      duckConfig: {
        voltageReference: "",
        samplingRate: "",
        sampleSize: "",
        sensors: []
      },
      occupiedChannels: [

      ],
      duckPeriod: 2048,
      avaliablePeriods: [
        {
          "index": 26,
          "value": 26,
          "friendly": "~30 minutes",
          "seconds": 2048,
          "minutes": 34,
          "hours": 0.5
        },
        {
          "index": 27,
          "value": 27,
          "friendly": "~1 hour",
          "seconds": 4096,
          "minutes": 68,
          "hours": 1
        },
        {
          "index": 28,
          "value": 28,
          "friendly": "~2 hours",
          "period": 13,
          "seconds": 8192,
          "minutes": 136,
          "hours": 2
        },
        {
          "index": 29,
          "value": 29,
          "friendly": "~4.5 hours",
          "period": 14,
          "seconds": 16384,
          "minutes": 273,
          "hours": 4.5
        },
        {
          "index": 30,
          "value": 30,
          "friendly": "~9 hours",
          "period": 15,
          "seconds": 32768,
          "minutes": 546,
          "hours": 9
        },
        {
          "index": 31,
          "value": 31,
          "friendly": "~18 hours",
          "period": 16,
          "seconds": 65536,
          "minutes": 1092,
          "hours": 18
        },
        {
          "index": 32,
          "value": 32,
          "friendly": "~36 hours",
          "period": 17,
          "seconds": 131072,
          "minutes": 2184,
          "hours": 36
        }
      ],
      samplingRates: [
        {
          value: 300,
          label: "300Hz"
        },
        {
          value: 600,
          label: "600Hz"
        },
        {
          value: 1200,
          label: "1200Hz"
        },
        {
          value: 2400,
          label: "2400Hz"
        },
        {
          value: 4800,
          label: "4800Hz"
        },

      ],
    };
  },
  async created() {
    await this.getDucks();
    if (this.ducks.length > 0) {
      this.selectedDuck = this.ducks[0];
      this.onDuckChange(this.selectedDuck);
    }
    await this.getSensors();
    await this.getTriggers();
  },
  computed: {
    ...mapState("trigger", ["triggers", "loading"]),
    duckSelector() {
      return this.ducks.map(x => {
        return {
          value: x,
          label: x.macAddress,
          key: x.id
        };
      });
    },
    ...mapState("duck", ["ducks"]),
    ...mapState("sensor", ["duckSensors"]),


  },
  methods: {
    ...mapActions("sensor", ["getSensors"]),
    ...mapActions("trigger", ["getTriggers", "updateStatusShadow"]),
    ...mapActions("duck", [
      "getDucks",
      "saveDuckConfig",
      "getDuckPeriodic",
      "saveDuckPeriodic",
      "deleteDuckPeriodic",
      "setDuckTrigger",
      "deleteDuckTrigger"
    ]),
    async updatePeriod() {
      if (this.selectedDuck) {
        await this.saveDuckPeriodic({ macAddress: this.selectedDuck.macAddress, period: this.duckPeriod });
        this.$message({
          message: this.$t("common.success"),
          type: "success"
        });
      }
    },
    async deletePeriodic() {
      if (this.selectedDuck) {
        await this.deleteDuckPeriodic(this.selectedDuck.macAddress);
        this.duckPeriod = "";
      }
    },
    async updateDuckTrigger() {
      await this.setDuckTrigger({ duck: this.selectedDuck.macAddress, trigger: this.selectedDuck.trigger });
      this.$message({
        message: this.$t("common.success"),
        type: "success"
      });
    },
    async removeDuckTrigger() {
      await this.deleteDuckTrigger({ duck: this.selectedDuck.macAddress, trigger: this.selectedDuck.trigger });
      this.$message({
        message: this.$t("common.success"),
        type: "success"
      });

      this.selectedDuck.trigger = "";
    },
    async onDuckChange() {
      if (this.selectedDuck) {
        this.duckConfig = {
          voltageReference: "",
          sampleSize: "",
          samplingRate: "",
          sensors: [],
          ...this.selectedDuck.config
        };
        try {
          this.duckPeriod = "";
          let periodic = await this.getDuckPeriodic(this.selectedDuck.macAddress);
          console.log(periodic);
          if (periodic) {
            this.duckPeriod = parseInt(periodic.data.repeatInterval);
          }
        } catch (e) {
          console.log(e);
        }
        //calculate occupied channels
        this.occupiedChannels = [];
        this.duckConfig.sensors.forEach(sensor => {
          sensor.channels.forEach(channel => {
            this.occupiedChannels.push(channel.order);
          });
        });

      }
    },

    async save() {
      let form = this.$refs.duckConfigForm;
      try {
        await form.validate();

        await this.saveDuckConfig({ id: this.selectedDuck.deviceId, duckConfig: this.duckConfig });
        //show success
        this.$message({
          message: this.$t("common.success"),
          type: "success"
        });
      } catch (e) {
        console.log(e);
      }
    },
    channelOptions(sensor) {

      let validChannels = this.duckSensors.find(item => item.sensor === sensor.name).channels;
      let d = validChannels.map(channel => {
        return {
          disabled: !validChannels.some(validSensorChannel => !sensor.channels.some(sc => sc.channel == validSensorChannel)),
          value: channel.channel,
          label: channel.displayName,
        };
      });
      return d;
    },
    deleteDuckSensor(i) {

      let [sensor] = this.duckConfig.sensors.splice(i, 1);
      //remove orders from occupied
      for (let { order } of sensor.channels) {

        this.occupiedChannels.splice(this.occupiedChannels.findIndex(x => x == order), 1);
      }
      if (this.activeSensor === i.toString()) {
        this.activeSensor = (this.duckConfig.sensors.length - 1).toString();
      }
    },

    addSensor() {
      let sensors = this.duckSensors;
      if (sensors.length == 0) {

        return;
      }

      let sensor = sensors[0];
      this.duckConfig.sensors.push({
        name: sensor.name,
        groupCode: "",
        displayName: sensor.displayName + "_" + this.duckConfig.sensors.filter(s => s.name == sensor.name).length,
        channels: []
      });
      if (this.duckConfig.sensors.length == 1) {
        this.activeSensor = (this.duckConfig.sensors.length - 1).toString();
      }
    },
    isDisabled(sensor, order) {
      if (sensor.channels.some(x => x.order == order)) {
        return false;
      }
      return this.occupiedChannels.includes(order);

    },
    toggleChannel(sensor, order) {

      const maxChannel = this.duckSensors.find(x => x.sensor == sensor.name).channels.length

      //check if already exists
      if (sensor.channels.some(x => x.order == order)) {
        //remove channel
        sensor.channels.splice(sensor.channels.findIndex(x => x.order == order), 1);
        //remove occuped
        this.occupiedChannels.splice(this.occupiedChannels.findIndex(x => x == order), 1);
      } else {
        //channel overflow control
        if (sensor.channels.length >= maxChannel) { return; }
        
        if (this.occupiedChannels.includes(order)) {
          return;
        }
        sensor.channels.push({
          order: order,
          channel: ""
        });

        //sort channel according to order
        sensor.channels.sort((a, b) => { return a.order - b.order; })

        //update duck sensor
        sensor.groupCode = sensor.channels.map(x => x.order).join("|");
        this.occupiedChannels.push(order);
      }
    },
  }
};
</script>
<style>
.duckConfig .el-tabs__header.is-left {
  margin-right: 0px
}

.duckConfig .el-tabs__content {
  margin-top: -16px;
}

.duckConfig .el-tabs--left.el-tabs--card .el-tabs__nav {
  border-bottom: 0px;
}
</style>
<style scoped>
.duckChannelSelect.active {
  background-color: rgb(249 123 20);
  border: 1px solid rgb(249 123 20);
  color: white;
}

.duckChannelSelect.disabled {
  background-color: #b6b6b6 !important;
  border: 1px solid #b6b6b6;
  color: #797474
}

.duckChannelSelect {
  text-align: center;
  line-height: 25px;
  border: 1px solid rgb(221 221 221);
  border-radius: 3px;
  float: left;
  margin-right: 10px;
  width: 25px;
  height: 25px;
  cursor: pointer;
}

.duckChannelSelect:hover:not(.disabled) {
  color: white;
  background-color: rgb(240, 155, 86);
  border: 1px solid rgb(240, 155, 86);
}
</style>